import ReferralClaimPage from "./ReferralClaimPage";
export default ReferralClaimPage;
